<div class="relative" style="display: contents;" #tooltipTrigger>
  <ng-content></ng-content>
  
  <div
    #tooltipContent
    *ngIf="showTooltip() && !disabled"
    [class]="tooltipClasses"
    [ngStyle]="tooltipStyles"
    class="fixed"
    style="z-index: 9999;">
    <ng-container *ngIf="templateRef; else textTemplate">
      <ng-container *ngTemplateOutlet="templateRef"></ng-container>
    </ng-container>
    <ng-template #textTemplate>
      {{ text }}
    </ng-template>
  </div>
</div>

